import getButtonStyle from '../utils/view/getButtonStyle';
import { DefaultButton, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';
import ActionButtonStyle from 'txp-data/lib/schema/viewSchema/ActionButtonStyle';

export interface ActionButtonProps {
    buttonElementText: string;
    style: ActionButtonStyle;
    controlIconName?: string;
    onClickHandler?: () => void;
    anchorLink?: string;
    target?: string;
    showSpinner?: boolean;
}

function ActionButton(props: ActionButtonProps) {
    let {
        buttonElementText,
        style,
        onClickHandler,
        anchorLink,
        target,
        controlIconName,
        showSpinner,
    } = props;

    let themeColorOverride = style.themeColor ? { color: style.themeColor } : null;
    let buttonStyles: IButtonStyles = getButtonStyle(style);

    const onRenderIcon = React.useCallback(() => {
        return showSpinner ? (
            <Spinner size={SpinnerSize.small} />
        ) : (
            <Icon className={style.iconStyle} iconName={controlIconName} />
        );
    }, [controlIconName, style.iconStyle]);

    return style.darkerColor ? (
        <DefaultButton
            role="button"
            onClick={onClickHandler}
            href={anchorLink ? anchorLink : null}
            target={target ? target : null}
            disabled={showSpinner}
            styles={buttonStyles}>
            {showSpinner ? (
                <Spinner size={SpinnerSize.small} />
            ) : (
                <Icon className={style.iconStyle} iconName={controlIconName} />
            )}
            <div className={style.buttonTextStyle}>{buttonElementText}</div>
        </DefaultButton>
    ) : (
        <CommandButton
            role="button"
            onClick={onClickHandler}
            href={anchorLink ? anchorLink : null}
            target={target ? target : null}
            disabled={showSpinner}
            style={themeColorOverride}
            styles={{ root: style.buttonStyle }}
            text={buttonElementText}
            onRenderIcon={onRenderIcon}>
            {/* <div className={style.buttonTextStyle}>{buttonElementText}</div> */}
        </CommandButton>
    );
}
export default ActionButton;
